





























import { parse } from 'date-fns';
import { getSerachViewMode } from './../../searchViewMode';
import { format, formatDistance, formatRelative, subDays, addDays } from "date-fns";
import Collapse from 'bootstrap/js/dist/collapse';
export default {
    props: {
        action: String,
        id: String,
        translationsObj: String
    },
    computed: {
        minDepartureDate() {
            return addDays(this.arrival, 1);
        },
        disableSubmitButton() {
            var ageGroupsFilled = false;
            this.ageCategories.map((ele) => {
                if (ageGroupsFilled == false)
                    ageGroupsFilled = ele.value > 0;
            });

            if (this.arrival != null && this.departure != null && ageGroupsFilled) {
                return false;
            }
            else {
                return true;
            }
        },
        translations() {
            const parsedObj = JSON.parse(this.translationsObj);
            return parsedObj;
        }
    },

    created() {
        //Find arrival og departure ud fra querystring
        this.ageCategories[0].name = this.getTranslation('Voksen');
        this.ageCategories[0].description = this.getTranslation('FromAge');
        this.ageCategories[1].name = this.getTranslation('Børn');
        this.ageCategories[1].ageDescription = this.getTranslation('FromChildrenAgeText');


        let urlParams = new URLSearchParams(window.location.search);
        this.arrival = urlParams.has('arrivalDate') ? parse(urlParams.get('arrivalDate'), "yyyy-MM-dd", new Date()) : null;
        this.departure = urlParams.has('departureDate') ? parse(urlParams.get('departureDate'), "yyyy-MM-dd", new Date()) : null;
        const ageList = urlParams.has('ageList') ? urlParams.get('ageList').split(',').map((val) => parseInt(val)) : null;

        const self = this;
        if (ageList != null) {
            const sortedArray: Number[] = ageList.sort();
            //Loop igennem hver tal og find den tilhørende ageCategory hvor tal er større end ageCategory.from order by fromDesc
            sortedArray.map((age, index) => {
                const indexOfArray = (<Object[]>self.ageCategories).findIndex((x: any) => {
                    return age >= x.from;
                });
                if (indexOfArray > -1) {
                    self.ageCategories[indexOfArray].value++;
                    self.ageCategories[indexOfArray].ageList.push(age);
                }
            });
        }
    },
    mounted() {
        console.log("translations:", this.translations);
        //Search Box filters
        var collapseSearchFilterElementList = [].slice.call(document.querySelectorAll('.field-dropdown'));
        this.collapseSearchList = <Collapse[]>collapseSearchFilterElementList.map(function (collapseSearchFilterEl: HTMLElement) {
            return new Collapse(collapseSearchFilterEl, { toggle: false, parent: ".search-box" });
        });

        collapseSearchFilterElementList.map((element: HTMLElement) => {
            element.previousElementSibling.addEventListener("click", () => {
                this.collapseSearchList.map((ele) => {
                    if (Collapse.getInstance(element) === ele) {
                        ele.toggle();
                    } else {
                        ele.hide();
                    }
                });
            });
        });

        document.addEventListener("click", (e) => {
            const concatArr: HTMLElement[] = [].concat(collapseSearchFilterElementList)
            concatArr.map((ele) => {
                if ((<HTMLElement>e.target).closest('.collapse') == null) {
                    Collapse.getInstance(ele).hide();
                }
            });
        });
    },
    data() {
        const self = this;
        return {
            collapseSearchList: null,
            viewMode: getSerachViewMode(),
            arrival: null,
            departure: null,
            ageCategories: [
                {
                    'name': 'Voksen',
                    'description': 'FromAge',
                    'value': 0,
                    'from': 18,
                    'selectAges': false,
                    'ageList': []
                },
                {
                    'name': 'Børn',
                    'description': '',
                    'value': 0,
                    'selectAges': true,
                    'ageDescription': 'FromChildrenAgeText',
                    'from': 0,
                    'ageList': []
                }
            ],
            translationsObjChanged: false,
        }
    },
    methods: {

        formatGuestList() {
            const self = this;
            const guestListFormatter: String[] = this.ageCategories.map((ele) => {

                return `${ele.value} ${ele.name}`;
            })
            return guestListFormatter.join(', ');
        },
        ageChange(event) {
            console.log(this.ageCategories[1].ageList);
        },
        updateDepartureDatepicker(event) {
            console.log(event, "Event Arrival");
            this.arrival = new Date(event.detail[0]);

            this.collapseSearchList.map((ele) => {
                if ((<HTMLElement>ele._element).id == 'departure-dialog') {
                    ele.show();
                } else {
                    ele.hide();
                }
            })

        },
        updatedepartureDate(event) {
            this.departure = new Date(event.detail[0]);

            this.collapseSearchList.map((ele) => {
                if ((<HTMLElement>ele._element).id == 'departure-dialog') {

                    ele.hide();
                }
            })
        },
        getTranslation(key) {
            if (this.translations != null) {
                return this.translations[key];
            } else {
                return key;
            }
        }
    }
}
